import { WidgetType } from 'widgets/WidgetType';
import { StreamDataHandlers } from 'streamsState/StreamDataService';
import { Dispatch, Store } from 'redux';
import {
    createReceiveMessageAction,
    createWatchStreamAction,
    createWidgetHandleStreamErrorAction,
    WidgetStreamHandleStreamErrorAction,
    WidgetStreamMessageReceiveAction,
    WidgetWatchStreamAction,
} from 'widgets/store/stream/actions';
import { StreamError } from 'streamsState/store/streamStatuses/StreamErrorState';

export function getStreamHandlers<TDataMessage>(
    dispatch: Dispatch<
        | WidgetWatchStreamAction
        | WidgetStreamMessageReceiveAction<TDataMessage>
        | WidgetStreamHandleStreamErrorAction
    >,
    widgetType: WidgetType,
    widgetKey: string,
    allowMultiStream?: boolean
) {
    return {
        onPending: (streamKey: string) =>
            dispatch(
                createWatchStreamAction(widgetType)(
                    widgetKey,
                    streamKey,
                    allowMultiStream
                )
            ),
        onMessage: (streamKey: string, data: TDataMessage) =>
            dispatch(
                createReceiveMessageAction<TDataMessage>(widgetType)(
                    widgetKey,
                    streamKey,
                    data,
                    allowMultiStream
                )
            ),
        onError: (streamKey: string, error: StreamError) => {
            dispatch(
                createWidgetHandleStreamErrorAction(widgetType)(
                    widgetKey,
                    streamKey,
                    error
                )
            );
        },
    };
}

export function buildStreamHandlers<TDataMessage>(
    store: Store,
    widgetType: WidgetType,
    widgetKey: string,
    allowMultiStream?: boolean
): StreamDataHandlers<TDataMessage> {
    return getStreamHandlers(
        store.dispatch,
        widgetType,
        widgetKey,
        allowMultiStream
    );
}
